import React from 'react';
import PropTypes from 'prop-types';

class OptionTable extends React.Component{
    render(){
        const {data} = this.props;
        return(
            <table className="content_option_table">
                <tbody>
                    <tr>
                        <th>option</th>
                        <th>description</th>
                    </tr>
                    {data.map( (obj, idx) => {
                        return( 
                            <tr key={idx}>
                                <td className="table_option">
                                    {obj.option.split('\n').map( (op, idx)=>{
                                        return(
                                            <label key={idx}>
                                                {op}<br/>
                                            </label>
                                        );
                                    } )}
                                </td>
                                <td >{obj.desc}</td>
                            </tr>
                        );
                    })}
                </tbody>
            </table>
        )
    }
}

OptionTable.propTypes={
    data: PropTypes.array.isRequired,
}

export default OptionTable;